import { useEffect } from 'react';
import isNil from 'lodash/isNil';
type PropsT = {
  mediaElement: HTMLVideoElement | HTMLAudioElement | null;
  playbackRate: number | null;
};
export function useUpdatePlaybackRate({
  mediaElement,
  playbackRate
}: PropsT) {
  useEffect(() => {
    if (isNil(playbackRate)) {
      return;
    }
    if (!mediaElement) {
      return;
    }
    // eslint-disable-next-line react-hooks/immutability
    mediaElement.playbackRate = playbackRate;
  }, [playbackRate, mediaElement]);
}